/** Current MCP revision used by the portal and the worker's modern endpoint. */
export const MCP_PROTOCOL_VERSION = '2026-07-28' as const

/** Compatibility revision used by current Codex clients. */
export const MCP_LEGACY_PROTOCOL_VERSION = '2025-06-18' as const
